"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientError = exports.APIError = void 0;
class APIError extends Error {
    constructor(statusCode, errors) {
        super("Something went wrong");
        this.statusCode = statusCode;
        this.errors = errors;
        Object.setPrototypeOf(this, APIError.prototype);
    }
}
exports.APIError = APIError;
class ClientError extends Error {
    constructor(statusCode, errors) {
        super("Something went wrong");
        this.statusCode = statusCode;
        this.errors = errors;
        Object.setPrototypeOf(this, ClientError.prototype);
    }
}
exports.ClientError = ClientError;
